import { Trip, TripType } from './TripWidget.interfaces';
import { Market } from '@shared/config/market/market.models';
import AssetBannerEN from '@/assets/widget/tp_banner_en.jpg';
import AssetBannerSV from '@/assets/widget/tp_banner_sv.jpg';
import AssetBannerDA from '@/assets/widget/tp_banner_da.jpg';
import AssetBannerNO from '@/assets/widget/tp_banner_no.jpg';
import AssetBannerFI from '@/assets/widget/tp_banner_fi.jpg';
import store from '@/store';

export function getSupportedTrip(
    code: string | null,
    days: number | undefined
): Trip | undefined {
    const market: Market = store.getters['general/getMarket'];

    if (code && market) {
        const trips = getSupportedTrips(TripType.Country, market, days);
        return trips.find((x) => x.code === code);
    }

    return undefined;
}

const getImage = (code: string, type: TripType, market: Market): string | null => {
    switch (code) {
        case 'BKK': {
            if (type === TripType.Country) {
                switch (market.locale) {
                    case 'sv':
                        return AssetBannerSV;
                    case 'no':
                        return AssetBannerNO;
                    case 'da':
                        return AssetBannerDA;
                    case 'fi':
                        return AssetBannerFI;
                    default:
                        return AssetBannerEN;
                }
            } else {
                return 'https://images.sembo.travel/ImageService/ImageHandler.ashx?service=sembo&nameOfImage=176998.jpg&resizeMode=FitOutside&width=600&height=450';
            }
        }

        default:
            return null;
    }
};

const getLabel = (code: string, type: TripType): string | null => {
    switch (code) {
        case 'BKK':
            return `trip_widget.BKK.label_${type.toLowerCase()}`;
        default:
            return null;
    }
};

function getSupportedTrips(type: TripType, market: Market, days: number | undefined): Trip[] {
    return [getTripBKK(type, market, days)];
}

function getTripBKK(type: TripType, market: Market, days: number | undefined): Trip {
    const bkkArrivalNights = 1;
    const bkkDepartureNights = 2;
    let hktNights = 12;

    if (days) {
        hktNights = Math.max(days - (bkkArrivalNights + bkkDepartureNights), 1);
    }

    const stops = [
        { code: 'BKK', nights: bkkArrivalNights },
        { code: 'HKT', nights: hktNights },
        { code: 'BKK', nights: bkkDepartureNights },
    ];

    return {
        type,
        stops,
        code: 'BKK',
        image: getImage('BKK', type, market),
        labelKey: getLabel('BKK', type),
        rows: [
            {
                icon: 'Wand',
                labelKey: 'trip_widget.BKK.usp_1',
            },
            {
                icon: 'Dollar',
                labelKey: 'trip_widget.BKK.usp_2',
            },
        ],
    };
}
